export default __webpack_public_path__ + "static/media/parth.8e372476.png";